"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const fetchApplicationServerKey = async () => {
  try {
    const response = await fetch("".concat(process.env.REACT_APP_PATH, "/Micado.WebEngine/Micado.WebEngine.IO.Api.WebPush/GetPublicKey.api"));
    const result = await response.json();
    const {
      key
    } = result || {};
    if (!key) return;
    return key;
  } catch (error) {
    console.error("fetch server key error:", error);
  }
};
var _default = exports.default = fetchApplicationServerKey;